<template>
    <div style="background-color: #FDFBF5; color: #85371F; height: calc(100vh - 0px); overflow: hidden" class="q-gutter-y-md">
        <div style="position: relative">
            <q-img src="~assets/ui/header.svg" fit="contain" />
            <div class="sot-font" style="position: absolute; top: 25px; left: 20px;">Клуб СОТ</div>
        </div>
        <div style="padding: 15px; padding-top: 0" class="text-center q-gutter-y-md">
            <div class="text-weight-bold text-subtitle1">
                Здесь ещё удобнее<br/>обучаться и участвовать<br/> в проектах Обрсоюза
            </div>
            <div>
                Для <strong>авторизации</strong> давайте подтвердим Ваш актуальный номер телефона.
            </div>
            <div>
                <PhoneInput ref="phone" v-model="tel" @keydown.enter="getSms" />
            </div>
            <div>
                <TextInput v-show="isCodeSent" ref="code" v-model="inputCode" label="Код из СМС сообщения" icon="vpn_key" />
            </div>
            <div>
                <DefaultButton :disabled="isCodeSent" label="Подтвердить номер по СМС" @click="getSms" />
            </div>
            <div>
                <div class="text-subtitle1 cursor-pointer" @click="skip">
                    Пропустить
                </div>
            </div>
        </div>
        <div style="position: absolute; bottom: 40px; margin-left: 20px;">
            <q-img src="~assets/ui/sot-bottom.svg" height="33px" width="33px" />
        </div>
    </div>
</template>

<script>
import PhoneInput from 'components/ui/PhoneInput';
import { sendSmsMessage } from 'boot/axios';
import DefaultButton from 'components/ui/common/DefaultButton';
import TextInput from 'components/ui/common/TextInput';

export default {
    name: 'PageConfirmTel',
    components: { TextInput, DefaultButton, PhoneInput },
    mounted () {
        const { user } = this.$store.state.pages;
        this.user = user;
        if (user) {
            const { tel } = user;
            this.tel = tel;
            /*
            if (tel && tel.length > 1) {
                this.tel = tel.slice(1).trim();
            }
            */
        }
    },
    watch: {
        inputCode (v) {
            if (v && v.length === 4) {
                this.$nextTick(() => {
                    this.confirm();
                });
            }
        },
    },
    computed: {
        pureTel () {
            let { tel } = this;
            tel = tel.replaceAll('+', '');
            tel = tel.replaceAll('(', '');
            tel = tel.replaceAll(')', '');
            tel = tel.replaceAll('-', '');
            tel = tel.replaceAll(' ', '');
            return tel;
        },
    },
    data () {
        return {
            user: undefined,
            tel: undefined,
            isCodeSent: false,
            loading: false,
            code: undefined,
            inputCode: undefined,
        };
    },
    methods: {
        getSms () {
            if (!this.tel) {
                this.$refs.tel.select();
                this.$q.notify('Введите номер телефона');
            }
            this.createCode();
        },
        createCode () {
            this.$db.users.createCode(this.pureTel).then((code) => {
                this.code = code;
                this.loading = false;
                this.isCodeSent = true;
                sendSmsMessage(this.pureTel, `Ваш код: ${code}`);
                this.$nextTick(() => {
                    this.$refs.code.select();
                });
            });
        },
        confirm () {
            if (!this.inputCode) {
                this.$refs.code.select();
                this.$q.notify('Введите код из СМС-сообщения');
                return;
            }
            if (+this.inputCode !== +this.code) {
                this.$refs.code.select();
                this.$q.notify('Неправильный код подтверждения');
                return;
            }
            const { user } = this.$store.state.pages;
            this.$db.users.validateTel(user.id, this.pureTel).then(() => {
                this.saveUrlQuery();
                window.removeEventListener('beforeunload', this.$q.onClosePage);
                window.location.reload();
            });
        },
        skip () {
            localStorage.setItem('skip-tel-validation', '1');
            this.saveUrlQuery();
            window.removeEventListener('beforeunload', this.$q.onClosePage);
            window.location.reload();
        },
        saveUrlQuery () {
            const q = this.$route.query;
            if (q.key) {
                localStorage.setItem('key', q.key);
            }
            if (q.task_id) {
                localStorage.setItem('task_id', q.task_id);
            }
            if (q.p) {
                localStorage.setItem('p', q.p);
            }
        },
    },
};
</script>

<style scoped>

</style>
